module.exports = __webpack_public_path__ + "static/picstagram-9316165763aa08cacec6218842ea892f.jpg";